$.defaultEffectSizeScaling = false;